import axios from "axios";
import { User } from "../models/user";
import { error, getAxiosConfig } from "../core/common_functions";
import { GenericRequestResult } from "../core/common_types";
import { City, Province } from "../models/regions_models";

export const RegionsApi = {
    async getProvinces(): Promise<Province[]> {
        try {
            let response = await axios.get(`${process.env.REACT_APP_API_URL}/regions/provinces`);

            if (response.status !== 200) {
                throw new Error(`Error fetching provinces: ${response.statusText}`);
            }

            const result = response.data as GenericRequestResult<Province[]>;

            if (!result.success) {
                throw new Error(`Error fetching provinces: ${result.message}`);
            }

            return result.data ?? [];
        } catch (e: any) {
            throw error(e);
        }
    },
    async findCities(province: string): Promise<City[]> {
        try {
            let response = await axios.get(`${process.env.REACT_APP_API_URL}/regions/find-cities?province=${province}`);

            if (response.status !== 200) {
                throw new Error(`Error fetching cities: ${response.statusText}`);
            }

            const result = response.data as GenericRequestResult<City[]>;

            if (!result.success) {
                throw new Error(`Error fetching cities: ${result.message}`);
            }

            return result.data ?? [];
        } catch (e: any) {
            throw error(e);
        }
    }
}